const state = reactive({
  categories: [],
})

export function useNewsCategories() {
  const storyblokApi = useStoryblokApi()

  async function fetchCategories() {
    const { data } = await storyblokApi.get('cdn/stories/', {
      version: 'published',
      starts_with: 'categories/news-categories/',
      is_startpage: false,
      per_page: 100,
    })

    state.categories = data.stories
  }

  const formattedCategories = computed(() =>
    state.categories.map(({ uuid, name }) => ({
      uuid,
      name,
    })),
  )

  return {
    ...toRefs(state),
    fetchCategories,
    formattedCategories,
  }
}
